enum AppVersion {
  Full = 'full',
  Lite = 'lite',
}

export default AppVersion;
